// @flow
export const whatsappURL = (phone: string, text: string): string => {
  return `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(text)}`;
};

const getCookie = (cookieName) => {
  const nameEquals = cookieName + "=";
  const cookiesArray = document.cookie.split(';');
  for(let i = 0; i < cookiesArray.length; i++) {
    let cookie = cookiesArray[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEquals) === 0) {
      return cookie.substring(nameEquals.length, cookie.length);
    }
  }
  return null;
};

export const loadGclid = (): string => {
  return getCookie('gclid') || '';
};
